import { render } from "./AddBlog.vue?vue&type=template&id=2c6a367c&scoped=true"
import script from "./AddBlog.vue?vue&type=script&lang=js"
export * from "./AddBlog.vue?vue&type=script&lang=js"

import "./AddBlog.vue?vue&type=style&index=0&id=2c6a367c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c6a367c"

export default script